import { render, staticRenderFns } from "./InvitationDialog.vue?vue&type=template&id=ad376522&scoped=true"
import script from "./InvitationDialog.vue?vue&type=script&lang=js"
export * from "./InvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./InvitationDialog.vue?vue&type=style&index=0&id=ad376522&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad376522",
  null
  
)

export default component.exports